import { PostalCodeModelData } from './models/PostalCodesModel'
import { AdminPostalCodeService } from './api/AdminPostalCodeService'

const PostalCodeModule = {
  namespaced: true,
  state: PostalCodeModelData(),
  getters: {
    fetchPostalCodeList: state => state.postalCodeList,
    fetchJurisdictionPostalCodeList: state => state.jurisdictionPostalCodeList
  },
  mutations: {
    setPostalCodeList (state, data) {
      state.postalCodeList = data.list
    },
    setjurisdictionPostalCodeList (state, data) {
      state.jurisdictionPostalCodeList = data.list
    }
  },
  actions: {
    /**
     * Get postal code list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getPostalCodeList ({ commit }, { resolve, reject, status = '' }) {
      try {
        const response = await AdminPostalCodeService.fetchPostalCodeList(status)
        const { success, data } = response.data
        if (success === true) {
          commit('setPostalCodeList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get postal code list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getJurisdictionForPostalCodeItem ({ commit }, { resolve, reject, id = '' }) {
      try {
        const response = await AdminPostalCodeService.fetchJurisdictionListForPostalCodeItem(id)
        const { success, data } = response.data
        if (success === true) {
          commit('setjurisdictionPostalCodeList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setjurisdictionPostalCodeList', {
            list: [{ 'jurisdictionName': 'No Jurisdiction Mapped' }]
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * edit code year record
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async addPostalCodeItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminPostalCodeService.addPostalCodeItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getPostalCodeList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * edit postal code record
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async editPostalCodeItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminPostalCodeService.editPostalCodeItem(editedData)
        const { success, data } = response.data
        if (success) {
          dispatch('getPostalCodeList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default PostalCodeModule
